<icc-list  [items]="sashTypes" itemImgHeight="medium" itemTemplate="itemImgTitle" (select)="selectSashType($event)"></icc-list>
